import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer">© 2026 SimRaceNick. All rights reserved</div>`
})
export class AppFooter {}
